/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../../../../magnolia/lib/MagnoliaPropertyHelper';

export default interface OneCTImage {
  topTitle ? : string;
  topTitleColor ? : number;
  title ? : string;
  titleColor ? : number;
  subText ? : string;
  subTextColor ? : number;
  image ? : Asset;
  pageLink ? : any;
  intLinkParam ? : string;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
  ctaTargetMode ? : string;
  ctaText ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  image: Object as() => Asset,
  pageLink: Object,
  intLinkParam: String,
  pdfLinkInDam: Object as() => Asset,
  showCtaAsPdf: Boolean,
  ctaTargetMode: String,
  ctaText: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  image: Object as() => Asset,
  pageLink: Object,
  intLinkParam: String,
  pdfLinkInDam: Object as() => Asset,
  showCtaAsPdf: Boolean,
  ctaTargetMode: String,
  ctaText: String,
  dataABId: String,
  metadata: Object,
}

export class OneCTImageBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class OneCTImageInstance implements OneCTImage {
      topTitle ? : string;
      topTitleColor ? : number;
      title ? : string;
      titleColor ? : number;
      subText ? : string;
      subTextColor ? : number;
      image ? : Asset;
      pageLink ? : any;
      intLinkParam ? : string;
      pdfLinkInDam ? : Asset;
      showCtaAsPdf ? : boolean;
      ctaTargetMode ? : string;
      ctaText ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (typeof this.image === 'object') {
          this.image = {
            ...this.image,
            link: this.image['@link'],
            name: this.image['@name'],
            path: this.image['@path'],
          };
        } else {
          this.image = null as any;
        }
        if (typeof this.pdfLinkInDam === 'object') {
          this.pdfLinkInDam = {
            ...this.pdfLinkInDam,
            link: this.pdfLinkInDam['@link'],
            name: this.pdfLinkInDam['@name'],
            path: this.pdfLinkInDam['@path'],
          };
        } else {
          this.pdfLinkInDam = null as any;
        }
      }
    }
    return new OneCTImageInstance(props);
  }
}
